import { useMutation } from "@apollo/client/react";

import { mutationDocuments } from "@smart/manage-gql-operations-dom";

export const useCreateMatter = () =>
  useMutation(mutationDocuments.createMatter);
